module.exports = __webpack_public_path__ + "molby_round-b744bb8f618ad45ae93d463fd2b20dcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/dk/molby_round.jpg
// module id = 1165
// module chunks = 1 2